import React, { useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';
import { useSlideGroupShortInfoStyles } from 'components/SlideGroups/utilities/styles';
import moment from 'moment/moment';
import { SHORT_MONTH_DAY_YEAR_WITH_COMMA_FORMAT } from 'utilities/dates_and_times';
import { TextWithLimitedWidth } from 'components/SlideGroups/components/TextWithLimitedWidth';
import { Link } from 'react-router-dom';
import { SLIDE_GROUPS_ROUTE } from 'constants/urls';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import AddIcon from '@mui/icons-material/Add';

// eslint-disable-next-line no-unused-vars
const compareProps = (prev, next) =>
  prev.slideGroup === next.slideGroup &&
  prev.hasSelectedSlides === next.hasSelectedSlides;

export const SlideGroupShortInfo = ({
  hasSelectedSlides,
  slideGroup,
  customClasses = {},
  onClick,
}) => {
  const { classes } = useSlideGroupShortInfoStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [isAdding, setIsAdding] = useState(false);

  const createDateFormatted = moment(slideGroup.created).format(
    SHORT_MONTH_DAY_YEAR_WITH_COMMA_FORMAT,
  );

  useEffect(() => {
    if (isLoading) {
      setIsLoading(false);
    }
  }, [hasSelectedSlides, isLoading]);

  useEffect(() => {
    if (isAdding) {
      setTimeout(() => setIsAdding(false), 3000);
    }
  }, [isAdding]);

  const handleRemoveClick = () => {
    setIsLoading(true);
    onClick();
  };

  const handleAddClick = () => {
    setIsAdding(true);
    handleRemoveClick();
  };

  const combinedClasses = { ...classes, ...customClasses };

  return (
    <Box className={combinedClasses.container}>
      <Box className={combinedClasses.alignCenteredCell}>
        <Link
          to={SLIDE_GROUPS_ROUTE.replace(':slideGroupUUID', slideGroup.uuid)}
          target="_blank"
        >
          <TextWithLimitedWidth
            value={slideGroup.name}
            containerClass={combinedClasses.groupNameContainer}
            textClass={combinedClasses.groupNameText}
          />
        </Link>
      </Box>
      <Box
        className={`${combinedClasses.groupCellText} ${combinedClasses.alignCenteredCell}`}
      >
        {slideGroup.slides?.length || 0}
      </Box>
      <Box
        className={`${combinedClasses.groupCellText} ${combinedClasses.alignCenteredCell}`}
      >
        {createDateFormatted}
      </Box>
      <Box className={combinedClasses.alignCenteredCell}>
        {/* eslint-disable-next-line no-nested-ternary */}
        {!isAdding && hasSelectedSlides ? (
          <Button
            color="secondary"
            variant="outlined"
            startIcon={<CloseIcon />}
            className={`${classes.btn} ${classes.removeBtn}`}
            onClick={handleRemoveClick}
          >
            REMOVE
          </Button>
        ) : isLoading || isAdding ? (
          <Button
            color="primary"
            variant="contained"
            startIcon={<CheckIcon />}
            className={classes.btn}
            disabled
          >
            ADDED
          </Button>
        ) : (
          <Button
            color="primary"
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAddClick}
            className={classes.btn}
          >
            ADD
          </Button>
        )}
      </Box>
    </Box>
  );
};
